'use client';

import React from 'react';

import classNames from 'classnames';

import {BlockSkeleton, TextSkeleton} from '@udemy-v2/react-reveal-components';

import styles from './trending-skills.module.scss';

const TOPIC_LIMIT = 3;
const CATEGORY_COLUMN_COUNT = 3;

/**
 * Loading chrome for Trending Skills — mirrors the loaded four-column layout:
 * top-skill (title + link + subtitle), section CTA, and three category columns.
 * The section heading stays real in {@link TrendingSkills}.
 */
export const TrendingSkillsSkeleton: React.FC = () => (
    <div className={styles.content} aria-busy="true" aria-hidden="true">
        <div className={styles['top-skill-with-cta']}>
            <div className={styles['top-skill']}>
                <TextSkeleton
                    className={styles['top-skill-skeleton']}
                    withTitle
                    lineCountPerParagraph={2}
                    justified
                />
            </div>
            <div className={styles['section-cta']}>
                <BlockSkeleton className={styles['section-cta-skeleton']} />
            </div>
        </div>

        <div className={styles['wrapped-trending-topics']}>
            {Array.from({length: CATEGORY_COLUMN_COUNT}).map((_, index) => (
                <div
                    key={`trending-skills-column-skeleton-${index}`}
                    className={classNames(styles.column, styles['category-skeleton-column'])}
                    data-purpose="trending-topics-column-skeleton"
                >
                    <TextSkeleton
                        className={styles['category-skeleton-fill']}
                        withTitle
                        lineCountPerParagraph={0}
                    />
                    {Array.from({length: TOPIC_LIMIT}).map((_, topicIndex) => (
                        <TextSkeleton
                            key={`trending-skills-topic-skeleton-${index}-${topicIndex}`}
                            className={styles['category-skeleton-fill']}
                            lineCountPerParagraph={2}
                            justified
                        />
                    ))}
                </div>
            ))}
        </div>
    </div>
);
